import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Police Poppins auto-hébergée (RGPD : aucune requête vers Google Fonts)
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
